<template>
  <a :href="pageUrl" :aria-label="buttonLabel" class="acc-notif-button secondary button expanded">
    <slot></slot>
  </a>
</template>
<script setup>
defineProps({
  pageUrl: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped></style>
